"use strict";

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _grid = require("./grid.styles");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  templateAreas: (0, _propTypes.shape)({
    xs: _propTypes.string,
    md: _propTypes.string
  }),
  templateColumns: (0, _propTypes.shape)({
    xs: _propTypes.string,
    md: _propTypes.string
  }),
  children: _propTypes.node
} : {};
var defaultProps = {
  templateAreas: {
    xs: 'none',
    md: 'none'
  },
  templateColumns: {
    xs: 'repeat(4, 1fr)',
    md: 'repeat(12, 1fr)'
  }
};

var Grid = function Grid(_ref) {
  var templateAreas = _ref.templateAreas,
      templateColumns = _ref.templateColumns,
      children = _ref.children,
      others = _objectWithoutProperties(_ref, ["templateAreas", "templateColumns", "children"]);

  return (0, _core.jsx)(_grid.Wrapper, (0, _extends2.default)({
    templateAreas: templateAreas,
    templateColumns: templateColumns
  }, others), children);
};

exports.Grid = Grid;
process.env.NODE_ENV !== "production" ? Grid.propTypes = propTypes : void 0;
Grid.defaultProps = defaultProps;
Grid.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Grid",
  "props": {
    "templateAreas": {
      "defaultValue": {
        "value": "{\n  xs: 'none',\n  md: 'none',\n}",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "xs": {
            "name": "string",
            "required": false
          },
          "md": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "templateColumns": {
      "defaultValue": {
        "value": "{\n  xs: 'repeat(4, 1fr)',\n  md: 'repeat(12, 1fr)',\n}",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "xs": {
            "name": "string",
            "required": false
          },
          "md": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};